var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDoubleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2958_22384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1709 11.4666L11.3476 12.6433L18.4026 5.58825L19.5809 6.76659L11.3476 14.9999L6.04427 9.69659L7.2226 8.51826L8.99344 10.2891L10.1709 11.4658V11.4666ZM10.1726 9.10992L14.2993 4.98242L15.4743 6.15742L11.3476 10.2849L10.1726 9.10992ZM7.81677 13.8224L6.63927 14.9999L1.33594 9.69659L2.51427 8.51826L3.69177 9.69576L3.69094 9.69659L7.81677 13.8224Z",
    fill: "#19AB4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2958_22384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoubleFill);
export default __webpack_public_path__ + "static/media/check-double-fill.8586d998c0da4c27fc4d86759171ff75.svg";
export { ForwardRef as ReactComponent };